var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpworthy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000160873433785708380660000016508089581283498378_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50.1 29.4",
    style: {
      enableBackground: "new 0 0 50.1 29.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2_00000049937223209910291100000006850839085499197879_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1,6v13.7c0,5.3,4.3,9.7,9.7,9.7s9.7-4.3,9.7-9.7V6H1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.4,9.3c0-0.3-0.3-0.5-0.6-0.5h-0.2v0.9h0.2C29.2,9.7,29.4,9.6,29.4,9.3L29.4,9.3z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.9,
    cy: 14.7,
    rx: 0.9,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5,13.7h-0.6v0.7h0.6c0.4,0,0.5-0.2,0.5-0.4C35.9,13.8,35.8,13.7,35.5,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2,6h-9.7v23h10.6v-3.7c4.9-0.5,8.8-4.6,8.8-9.6C40.9,10.3,36.6,6,31.2,6L31.2,6z M33.1,14.7c0,1.3-1,2.2-2.2,2.2 c-1.2,0-2.2-0.9-2.2-2.2s1-2.2,2.2-2.2C32.2,12.5,33.1,13.4,33.1,14.7z M27.4,7.8H29c1.1,0,1.6,0.7,1.6,1.5s-0.5,1.5-1.6,1.5 h-0.4V12h-1.2C27.4,12,27.4,7.8,27.4,7.8z M23.3,7.8h1.2v2.5c0,0.4,0.2,0.6,0.5,0.6c0.4,0,0.5-0.2,0.5-0.6V7.8h1.2v2.8 c0,0.8-0.6,1.5-1.7,1.5s-1.7-0.7-1.7-1.5C23.3,10.5,23.3,7.8,23.3,7.8z M24.2,12.6l0.4,2.4h0l0.6-2.4h1.1L27,15h0l0.4-2.4h1.3 l-0.9,4.2h-1.4l-0.6-2.3l-0.5,2.3h-1.4l-0.9-4.2C22.9,12.6,24.2,12.6,24.2,12.6z M33.4,20v1.6h-1.2V20l-1.5-2.6v4.2h-1.2V20h-1.3 v1.5H27v-3.1h-1.2v3.1h-1.2v-3.1h-1.2v-1.1h4.8v1.5h1.3v-1.5h1.2h1.5l0.6,1.2h0l0.7-1.2h1.4L33.4,20L33.4,20z M36,16.8l-0.7-1.4 h-0.4v1.4h-1.2v-4.2h1.9c1,0,1.6,0.6,1.6,1.4c0,0.6-0.3,1-0.8,1.2l0.9,1.6H36L36,16.8z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.2,5.3V19c0,5.3,4.3,9.7,9.7,9.7s9.7-4.3,9.7-9.7V5.3H0.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.7,8.6c0-0.3-0.3-0.5-0.6-0.5h-0.2v0.9h0.2C28.4,9.1,28.7,8.9,28.7,8.6L28.7,8.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 30.2,
    cy: 14,
    rx: 0.9,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.7,13h-0.6v0.7h0.6c0.4,0,0.5-0.2,0.5-0.4C35.2,13.2,35.1,13,34.7,13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.5,5.3h-9.7v23h10.6v-3.7c4.9-0.5,8.8-4.6,8.8-9.6C40.2,9.6,35.8,5.3,30.5,5.3L30.5,5.3z M32.4,14 c0,1.3-1,2.2-2.2,2.2C29,16.2,28,15.3,28,14s1-2.2,2.2-2.2C31.4,11.9,32.4,12.8,32.4,14z M26.7,7.1h1.6c1.1,0,1.6,0.7,1.6,1.5 s-0.5,1.5-1.6,1.5h-0.4v1.2h-1.2C26.7,11.3,26.7,7.1,26.7,7.1z M22.6,7.1h1.2v2.5c0,0.4,0.2,0.6,0.5,0.6c0.4,0,0.5-0.2,0.5-0.6 V7.1h1.2v2.8c0,0.8-0.6,1.5-1.7,1.5c-1.1,0-1.7-0.7-1.7-1.5C22.6,9.9,22.6,7.1,22.6,7.1z M23.5,11.9l0.4,2.4h0l0.6-2.4h1.1 l0.6,2.4h0l0.4-2.4h1.3L27,16.1h-1.4L25,13.8l-0.5,2.3h-1.4l-0.9-4.2C22.2,11.9,23.5,11.9,23.5,11.9z M32.6,19.3v1.6h-1.2v-1.6 l-1.5-2.6v4.2h-1.2v-1.5h-1.3v1.5h-1.2v-3.1H25v3.1h-1.2v-3.1h-1.2v-1.1h4.8v1.5h1.3v-1.5h1.2h1.5l0.6,1.2h0l0.7-1.2h1.4 L32.6,19.3L32.6,19.3z M35.3,16.1l-0.7-1.4h-0.4v1.4h-1.2v-4.2h1.9c1,0,1.6,0.6,1.6,1.4c0,0.6-0.3,1-0.8,1.2l0.9,1.6H35.3 L35.3,16.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpworthy);
export default __webpack_public_path__ + "static/media/upworthy.987e5115447cd000fafe3940b0ea07bb.svg";
export { ForwardRef as ReactComponent };